import './pdf-viewer-page.scss'

import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';


import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    props: ['pdf', 'pageIndex', 'highlighted', 'scale'],
    template: require('./pdf-viewer-page.html')
})
export class PDFViewerPage extends ReactiveVue {

    public pdf: any;
    public pageIndex: any;
    public highlighted: any;
    public scale: number;

    private renderingInProgress: boolean = false;
    private ready = false;

    // tslint:disable-next-line:member-ordering
    public $refs: {
        pdfCanvas: HTMLCanvasElement
    }

    private setupPage(pageIndex) {
        if (this.pdf && !this.renderingInProgress) {
            this.renderingInProgress = true;
            this.pdf.getPage(pageIndex).then((page) => {

                const viewport = page.getViewport({ scale: this.scale });

                // Prepare canvas using PDF page dimensions
                const context = this.pdfCanvas.getContext('2d');
                this.pdfCanvas.height = viewport.height;
                this.pdfCanvas.width = viewport.width;

                // Render PDF page into canvas context
                const renderContext = {
                    canvasContext: context,
                    viewport
                };
                const renderTask = page.render(renderContext);
                renderTask.promise.then(() => {
                    this.ready = true;
                    this.renderingInProgress = false;
                });
            });
        }
    }

    private get pdfCanvas() {
        return this.$refs.pdfCanvas;
    }

    @Watch('pageIndex', { immediate: true })
    private onPageIndexChange(pageIndex) {
        this.setupPage(pageIndex)
    }

    @Watch('scale')
    private onScaleChange() {
        this.setupPage(this.pageIndex)
    }

}